import $ from 'jquery';
import slick from 'slick-carousel';
import matchHeight from 'jquery-match-height';

const setBannerSlider = () => {
  const $slider = $('.bannerSlider');
  if ($slider.length < 1) { return; }
  $slider.slick({
    mobileFirst: true,
    dots: true,
    centerMode: true,
    variableWidth: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 3,
          variableWidth: false
        }
      }
    ]
  });
};

class newsSlider {
  constructor ($el) {
    this.$el = $el;
  }

  set() {
    const $slider = $(this.$el);
    if ($slider.length < 1) { return; }
    $slider.slick({
      mobileFirst: true,
      centerMode: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            initialSlide: 1
          }
        }
      ]
    });
    $slider.find('.newsSlider_body').matchHeight();
  }

  destroy() {
    this.$el.slick('unslick');
  }
}

const setNewsSlider = () => {
  const slider = new newsSlider($('.newsSlider'));
  slider.set();
};

const reloadNewsSlider = ($el) => {
  const slider = new newsSlider($el);
  slider.destroy();
  slider.set();
}

const setMegaHeadingSlider = () => {
  const $slider = $('.megaHeadingSlider');
  if ($slider.length < 1) { return; }
  $slider.slick({
    dots : true
  });
};

module.exports = {
  setBannerSlider      : setBannerSlider,
  setNewsSlider        : setNewsSlider,
  reloadNewsSlider     : reloadNewsSlider,
  setMegaHeadingSlider : setMegaHeadingSlider
};



// WEBPACK FOOTER //
// ./src/js/modules/slider.js